import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

function Bloco({ children, maxHeight, padding, top }) {
  return <Container maxHeight={maxHeight} padding={padding} top={top}>
    {children}
         </Container>;
}

export default Bloco;

Bloco.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  maxHeight: PropTypes.bool,
};

Bloco.defaultProps = {
  maxHeight: false,
};
